import { useLocation } from '@remix-run/react'
import posthog from 'posthog-js'
import { useEffect } from 'react'

import usePosthogInitialized from './usePosthogInitialized'

import { getRouteContext } from '~/utils/routeSection.util'

export default function usePosthogPageview() {
  const initialized = usePosthogInitialized()
  let location = useLocation()

  useEffect(() => {
    if (!initialized) return

    const { routeSection, entityId } = getRouteContext(location.pathname)

    posthog.capture('$pageview', {
      routeSection,
      entityId,
    })
  }, [location, initialized])
}
